module.exports = __webpack_public_path__ + "assets/img/28979.png?26e82e86e66218474579098a2792236b";